import type { RouteRecordRaw } from 'vue-router';

const regionPage = () => import('@/pages/region/ui/RegionPage.vue');

/** Описывает стабильный и временный staging-маршрут одной region-страницы. */
export const mfRoutes: RouteRecordRaw[] = [
  {
    path: '/destinations/regions/:slug/',
    name: 'region',
    component: regionPage,
    meta: { destinationType: 'region', soguName: 'destinations-region' },
  },
  {
    path: '/v2/destinations/regions/:slug/',
    name: 'region-staging-v2',
    component: regionPage,
    meta: { destinationType: 'region', soguName: 'destinations-region' },
  },
];
